<section id="about">
  <div class="grid-container">
    <div>
      <h3 class="title">درباره ما</h3>

      <p class="text-justify" style="line-height: 30px; text-align: justify">
        سامانه <b>ردیاب قصر شیرین</b> با هدف هوشمندسازی و سامان‌دهی ناوگان
        حمل‌ونقل در محدوده منطقه آزاد تجاری-صنعتی قصر شیرین و با نظارت سازمان
        منطقه آزاد، ایجاد شده است. این سامانه بستری مدرن، شفاف و قابل‌اطمینان را
        برای پایش دقیق، مدیریت بهینه و نظارت بر تردد ناوگان فراهم می‌کند. این
        سامانه با هدف نظارت لحظه‌ای بر تردد و عملکرد خودروها، مدیریت بهینه
        ناوگان در محدوده منطقه آزاد، افزایش شفافیت در عملیات لجستیک، جلوگیری از
        تردد‌های غیرمجاز و تسهیل فرایندهای بازرگانی طراحی و پیاده‌سازی شده است.
      </p>
    </div>
    <div>
      <h3 class="title">راه های ارتباطی</h3>

      <div class="">
        <ul style="line-height: 33px">
          <ng-container *ngFor="let item of lst_Contact">
            <li>
              <strong>{{ item.title }}: </strong> {{ item.description | faNum }}
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="partners-container">
        <div class="co-worker" title="ردیاب قصیر شیرین">
          <img
            src="../../../assets/imgs/Shahrnik_Logo_Public_new.png"
            alt="ردیاب قصیر شیرین"
          />
        </div>
        <div class="co-worker" title="ویگو | ارائه دهنده تخصصی انواع ردیاب">
          <img
            src="../../../assets/imgs/e-wigo.png"
            alt="ویگو | ارائه دهنده تخصصی انواع ردیاب"
          />
        </div>
        <div class="co-worker" title="شرکت دانش‌بنیان رایان اندیشه نصر">
          <img
            src="../../../assets/imgs/andisheh.png"
            alt="شرکت دانش‌بنیان رایان اندیشه نصر"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<footer id="site-footer">
  <div class="inner-content">
    <div class="flex-container">
      <a href="https://rayanandisheh.com" class="copyright" target="_blank"
        >طراحی و توسعه شرکت دانش بنیان رایان اندیشه نصر</a
      >
    </div>
  </div>
</footer>
